export default {
      id: "icon-services-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#icon-services",
      toString: function () {
        return this.url;
      }
    }